const styles = () => ({
  google_btn_text: {
    left: -4,
    backgroundColor: '#4285F4',
    fontFamily: 'Roboto, sans-serif',
  },
});

export default styles;
